import { baseApi } from './baseApi'

import { BillingSettingsDto, UpdateBillingSettingsDto } from 'store/types'

export const billingSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBillingSettings: builder.query<BillingSettingsDto, void>({
      query: () => ({ url: '/lab/settings/billing' }),
      providesTags: ['BillingSettings'],
    }),
    updateBillingSettings: builder.mutation<BillingSettingsDto, UpdateBillingSettingsDto>({
      query: (body) => ({
        url: '/lab/settings/billing',
        method: 'PATCH',
        body,
      }),
      // The minimum decides which balances get statemented at all, so the
      // worklist has to be re-read once it changes.
      invalidatesTags: ['BillingSettings', 'PatientStatements'],
    }),
  }),
})

export const {
  useGetBillingSettingsQuery,
  useUpdateBillingSettingsMutation,
} = billingSettingsApi
